var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#57acfc;}.cls-2{fill:#7877f7;}.cls-3{fill:#d6fefe;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.41,478.18,540,390.77l-87.41,87.41a123.63,123.63,0,1,0,174.82,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M598.7,506.89,540,448.19l-58.7,58.7a83,83,0,1,0,117.4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M570,535.61l-30-30-30,30a42.42,42.42,0,1,0,60,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationLogo);
export default __webpack_public_path__ + "static/media/organizationLogo.0c55ee06e8918f67caadf3cc52149cb6.svg";
export { ForwardRef as ReactComponent };